document.addEventListener("DOMContentLoaded", () => {
  const logoWrapper = document.querySelector(".header__heading-logo-wrapper");
  const header = document.querySelector(".header");

  if (logoWrapper && header && window.location.hostname === "theeonai.com") {
    logoWrapper.innerHTML = "";

    const mainLogo = document.createElement("img");
    mainLogo.src =
      window.location.pathname === "/"
        ? "https://cdn.shopify.com/s/files/1/0625/4952/4579/files/Onai_Logo_-_white.svg?v=1741525925"
        : "https://cdn.shopify.com/s/files/1/0625/4952/4579/files/ONAI_LOGO-141X30-BLACK.svg?v=1743090224";
    mainLogo.classList.add("main-logo");

    const scrollLogo = document.createElement("img");
    scrollLogo.src =
      window.location.pathname === "/"
        ? "https://cdn.shopify.com/s/files/1/0625/4952/4579/files/ONAI_SYMBOL-108X30-WHITE.svg?v=1743158865"
        : "https://cdn.shopify.com/s/files/1/0625/4952/4579/files/ONAI_SYMBOL-108X30-BLACK.svg?v=1743158696";
    scrollLogo.classList.add("scroll-logo");
    scrollLogo.style.display = "none";

    const hoverLogo = document.createElement("img");
    hoverLogo.src =
      "https://cdn.shopify.com/s/files/1/0625/4952/4579/files/ONAI_LOGO-141X30-BLACK.svg?v=1743090224";
    hoverLogo.classList.add("hover-logo");
    hoverLogo.style.display = "none";

    logoWrapper.appendChild(mainLogo);
    logoWrapper.appendChild(scrollLogo);
    if (window.location.pathname === "/") {
      logoWrapper.appendChild(hoverLogo);
    }

    let isHovering = false; // 👈 New flag to track hover

    // Scroll effect
    window.addEventListener("scroll", () => {
      if (isHovering) {
        // 👈 While hovering, ignore scroll changes
        return;
      }
      if (window.scrollY > 100) {
        mainLogo.style.display = "none";
        scrollLogo.style.display = "block";
        if (window.location.pathname === "/") {
          hoverLogo.style.display = "none";
        }
      } else {
        mainLogo.style.display = "block";
        scrollLogo.style.display = "none";
      }
    });

    // Hover effect on home page
    if (window.location.pathname === "/") {
      header.addEventListener("mouseenter", () => {
        isHovering = true; // 👈 Set hovering
        mainLogo.style.display = "none";
        scrollLogo.style.display = "none";
        hoverLogo.style.display = "block";
      });

      header.addEventListener("mouseleave", () => {
        isHovering = false; // 👈 Remove hovering
        if (window.scrollY > 100) {
          hoverLogo.style.display = "none";
          scrollLogo.style.display = "block";
        } else {
          hoverLogo.style.display = "none";
          mainLogo.style.display = "block";
        }
      });
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const intervalId = setInterval(() => {
    const hamburger = document.querySelector(".header__icon--menu");
    const detailsContainer = document.getElementById(
      "Details-menu-drawer-container"
    );

    if (hamburger && detailsContainer) {
      clearInterval(intervalId);

      // When user clicks hamburger
      hamburger.addEventListener("click", function (event) {
        event.preventDefault(); // Always stop default

        // Manually fire "toggle" event to match Shopify's expected behavior
        if (!detailsContainer.hasAttribute("open")) {
          detailsContainer.setAttribute("open", "");
        } else {
          detailsContainer.removeAttribute("open");
        }

        // Publish a custom PubSub event if needed
        if (window.Shopify && window.Shopify.PubSub) {
          window.Shopify.PubSub.publish("details:toggle", {
            id: detailsContainer.id,
            open: detailsContainer.hasAttribute("open"),
          });
        }
      });
    }
  }, 300);
});

document.addEventListener("DOMContentLoaded", function () {
  const waitForSummary = setInterval(function () {
    const summary = document.querySelector(".header__icon--menu");
    const details = document.querySelector("#Details-menu-drawer-container");

    if (summary && details) {
      clearInterval(waitForSummary);

      summary.addEventListener("click", function (e) {
        if (!details.hasAttribute("open")) {
          summary.focus();
          summary.blur();
        }
      });
    }
  }, 300);
});
